import React, { Component } from 'react'

import classes from './EmailServer.scss'
import {
  checkValidity,
  updateFilterOptions,
  getPageStatus,
  updateObject
} from '../../../../helpers/utils'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Button from '../../../../components/UI/Button/Button'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import DataTable from '../../../../components/DataTable/DataTable'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import Form from '../../../../components/PageContent/Settings/EmailServer/Form/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import Alert from '../../../../components/Alert/Alert'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import { Checkbox } from '@material-ui/core'
import { Edit, Delete, Add } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'

class EmailServer extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    action: 'add',
    actionRecordId: null,
    formValid: false,
    searchText: '',
    withSeq: true,
    filter: {},
    inputGroups: {
      email_server_name: {
        label: this.props.translate('eMailServer'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('eMailServer')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      mail_driver: {
        label: this.props.translate('mailDriver'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('mailDriver')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      mail_host: {
        label: this.props.translate('mailHost'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('mailHost')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      mail_port: {
        label: this.props.translate('mailPort'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('mailPort')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      mail_username: {
        label: this.props.translate('mailUsername'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('mailUsername')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      mail_password: {
        label: this.props.translate('mailPassword'),
        elementType: 'input',
        elementConfig: {
          type: 'password',
          autoComplete: 'off',
          placeholder: this.props.translate('mailPassword')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      mail_encryption: {
        label: this.props.translate('mailEncryption'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('mailEncryption')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      web_domain: {
        label: this.props.translate('webDomain'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('webDomain')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },

      is_active: {
        label: this.props.translate('active'),
        elementType: 'checkbox',
        value: true,
        validation: false,
        valid: true
      }
    },
    filterControls: {
      emailServer_id: {
        label: this.props.translate('eMailServer'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('eMailServer'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('eMailServer')
            }
          ]
        }
      },
      is_active: {
        label: this.props.translate('active'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('active'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('active') }
          ]
        }
      }
    },
    updateProps: {
      selectedRecord: this.props.selectedRecord,
      filterEmailServer: this.props.filterEmailServer
    }
  }
  rowActions = [
    {
      icon: () => <Add />,
      tooltip: this.props.translate('add') + this.props.translate('eMailServer'),
      onClick: () => this.openModalHandler('add'),
      isFreeAction: true,
      disabled: !this.props.pagePermission.is_add
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: this.props.translate('edit') + this.props.translate('eMailServer'),
      onClick: (event, rowData) => this.openModalHandler('edit', rowData.email_server_id),
      disabled: !this.props.pagePermission.is_edit
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: this.props.translate('delete') + this.props.translate('eMailServer'),
      onClick: (event, rowData) => this.openModalHandler('delete', rowData.email_server_id),
      disabled: !this.props.pagePermission.is_delete
    }
  ]

  tableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    { field: 'email_server_name', title: this.props.translate('mailDriver'), type: 'string' },
    { field: 'mail_host', title: this.props.translate('mailHost'), type: 'string' },
    { field: 'mail_port', title: this.props.translate('mailPort'), type: 'string' },
    { field: 'mail_username', title: this.props.translate('mailUsername'), type: 'string' },
    {
      field: 'is_active',
      title: this.props.translate('active'),
      render: rowData => {
        return <Checkbox className={classes.Checkbox} checked={!!rowData.is_active} disabled />
      },
      width: 100
    }
  ]

  componentDidMount() {
    this.props.fetchEmailServer()
  }
  componentDidUpdate(prevprops) {
    if (prevprops.success !== this.props.success && this.props.success) {
      this.closeModal()
      this.clearInput()
      this.props.clearSelectedRecord()
      this.setState({
        actionRecordId: null
      })
    }
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state

    const updateFilter = (stateId, propsId, attr) => {
      let [attrId, attrName] = attr

      updatedState = {
        ...updatedState,
        filterControls: {
          ...state.filterControls,
          [stateId]: updateFilterOptions(
            props[propsId],
            state.filterControls[stateId],
            attrId,
            attrId,
            attrName,
            null,
            null,
            state.filterControls[stateId].value
          )
        },
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      }
    }

    if (props.filterEmailServer !== updateProps.filterEmailServer) {
      updateFilter('emailServer_id', 'filterEmailServer', ['email_server_id', 'email_server_name'])
    }
    if (props.selectedRecord !== updateProps.selectedRecord) {
      let newEmailData = Object.entries(state.inputGroups).reduce((emailGroups, email) => {
        let [emailKey, emailAttrs] = email
        let value = ''
        let valid = false
        let touched = false
        let errorMessage = null
        if (emailAttrs.elementType === 'checkbox') {
          value = false
        }
        if (props.selectedRecord && props.selectedRecord[emailKey]) {
          value = props.selectedRecord[emailKey]

          let { isValid, error } = checkValidity(value, emailAttrs.validation, emailAttrs.label)
          if (emailAttrs.elementType === 'newselect') {
            value = state.inputGroups[emailKey].elementConfig.options.find(
              res => res.value === value
            )
          }
          if (emailAttrs.elementType === 'checkbox') {
            value = true
          }
          valid = isValid
          errorMessage = error
        }

        const newEmailAttrs = {
          ...emailAttrs,
          value: value,
          valid: valid,
          error: errorMessage,
          touched: touched
        }

        return updateObject(emailGroups, { [emailKey]: { ...newEmailAttrs } })
      }, {})

      updatedState = {
        ...updatedState,
        formValid: true,
        inputGroups: newEmailData,
        updateProps: {
          ...updateProps,
          selectedRecord: props.selectedRecord
        }
      }
    }
    return updatedState
  }

  onPageChangeHandler = (e, page) => {
    this.props.fetchEmailServer({
      page: page,
      perPage: this.props.pagination.perPage
    })
  }

  onPerPageChangeHandler = perPage => {
    this.props.fetchEmailServer({
      currentPage: this.props.pagination.currentPage,
      perPage
    })
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({
      searchText: searchText
    })
  }
  clearInput = () => {
    let newFormData = Object.entries(this.state.inputGroups).reduce((formGroups, form) => {
      let [formKey, formAttrs] = form
      let newFormAttrs
      switch (formKey) {
        case 'is_active':
          newFormAttrs = {
            ...formAttrs,
            value: false
          }
          break

        default:
          newFormAttrs = {
            ...formAttrs,
            value: ''
          }
          break
      }

      return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
    }, {})
    this.setState({ inputGroups: newFormData })
  }
  openModalHandler = (action, recordId) => {
    if (recordId && action === 'edit') {
      this.props.fetchEmailServerById(recordId)
    }
    this.setState({
      action: action,
      actionRecordId: recordId
    })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.openModal()
    }
  }

  openModal = () => {
    this.clearInput()
    this.setState({
      modalOpen: true
    })
  }

  closeModal = () => {
    this.setState({
      modalOpen: false
    })
  }
  clearModal = () => {
    this.closeModal()
    this.clearInput()
    this.props.clearSelectedRecord()
    this.setState({
      actionRecordId: null
    })
  }

  emailServerSubmitHandler = e => {
    e.preventDefault()

    let emailServerData = Object.entries(this.state.inputGroups).reduce(
      (emailServerData, emailServerEntry) => {
        let [emailServerKey, emailServerAttrs] = emailServerEntry
        let value = ''
        if (emailServerAttrs.elementType === 'newselect') {
          value = emailServerAttrs.value?.value
        } else {
          value = emailServerAttrs.value
        }
        return { ...emailServerData, [emailServerKey]: value }
      },
      {}
    )

    if (this.state.action === 'add') {
      this.props.createEmailServer(
        { ...emailServerData },
        getPageStatus(this.props.pagination, false)
      )
    } else if (this.state.action === 'edit') {
      this.props.updateEmailServer(
        this.state.actionRecordId,
        { ...emailServerData },
        getPageStatus(this.props.pagination, false)
      )
    }
  }

  inputChangeHandler = (groupKey, emailServerKey, event) => {
    const inputGroup = this.state.inputGroups
    const emailServerItem = inputGroup[emailServerKey]
    let inputValue = ''

    switch (emailServerItem.elementType) {
      case 'checkbox':
        inputValue = !emailServerItem.value
        break
      default:
        inputValue = event.target.value
        break
    }
    const { isValid, error } = checkValidity(
      inputValue,
      emailServerItem.validation,
      emailServerItem.label
    )

    const updatedEmailServerItem = {
      ...emailServerItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }

    let formIsValid = true
    const updateGroup = updateObject(inputGroup, { [emailServerKey]: updatedEmailServerItem })
    Object.values(updateGroup).map(attr => {
      return (formIsValid = formIsValid && attr.valid)
    })

    this.setState({
      inputGroups: updateObject(this.state.inputGroups, {
        [emailServerKey]: updatedEmailServerItem
      }),
      formValid: formIsValid
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false
    })
  }

  openConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data

      return (filterControls = {
        ...filterControls,
        [datakey]: { ...filterControls[datakey], value: '' }
      })
    })

    this.props.fetchFilter()

    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      filter: []
    })
  }
  deleteRecord = () => {
    const recordId = this.state.actionRecordId

    this.props.deleteEmailServer(recordId, getPageStatus(this.props.pagination, true))

    this.closeConfirmationModal()
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]

    this.setState(
      {
        filterControls: updateObject(this.state.filterControls, {
          [itemKey]: updateObject({ filterItem, value: filterValue })
        }),
        filter: { ...this.state.filter, [itemKey]: filterValue?.value }
      },
      () => {
        this.props.fetchFilter(this.state.filter)
      }
    )
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    let param = { ...this.state.filter, page: 1, perPage: 10 }
    this.props.fetchEmailServer(param)
    this.closeFilterModal()
  }

  render() {
    let emailServerLabel = <Spinner />

    if (!this.props.loading) {
      emailServerLabel = Object.entries(this.state.inputGroups).map((item, key) => {
        return (
          <Form
            key={key}
            form={item}
            inputChanged={(emailServerKey, e) => this.inputChangeHandler(key, emailServerKey, e)}
            formValid={this.state.formIsValid}
          />
        )
      })
    }

    const buttonGroups = (
      <div className={classes.ButtonGroup}>
        <span className={classes.Button}>
          <Button
            color={'primary'}
            clicked={this.emailServerSubmitHandler}
            disabled={!this.state.formValid}>
            {this.props.translate('save')}
          </Button>
        </span>
        <span className={classes.Button}>
          <Button color={'default'} clicked={this.clearModal}>
            {this.props.translate('cancel')}
          </Button>
        </span>
      </div>
    )

    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate(this.state.action) + this.props.translate('eMailServer')}
          backdropClicked={this.closeModal}
          footer={buttonGroups}>
          <div className={classes.ModalBody}>{emailServerLabel}</div>
        </Modal>
        <div className={classes.EmailServerWrapper}>
          <Card>
            <CardHeader>
              <FilterBar buttonClicked={this.openFilterModal} />
            </CardHeader>
            <CardBody>
              <DataTable
                tableTitle={this.props.translate('eMailServer')}
                data={this.props.data}
                structure={this.tableStructure}
                loading={this.props.loading}
                pagination={this.props.pagination}
                pageChange={this.onPageChangeHandler}
                perPageChange={this.onPerPageChangeHandler}
                rowActions={this.rowActions}
              />
            </CardBody>
          </Card>
        </div>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.emailServer.pagination,
    data: state.emailServer.records,
    loading: state.emailServer.loading,
    filterLoading: state.emailServer.filterLoading,
    success: state.emailServer.success,
    selectedRecord: state.emailServer.selectedRecord,
    filterEmailServer: state.emailServer.filterEmailServer
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchEmailServer: filterOptions => dispatch(actions.fetchEmailServer(filterOptions)),
    fetchEmailServerById: recordId => dispatch(actions.fetchEmailServerById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedEmailServerRecord()),
    createEmailServer: (recordData, page) => dispatch(actions.createEmailServer(recordData, page)),
    updateEmailServer: (recordId, recordData, page) =>
      dispatch(actions.updateEmailServer(recordId, recordData, page)),
    deleteEmailServer: (recordId, page) => dispatch(actions.deleteEmailServer(recordId, page)),
    fetchFilter: filter => {
      dispatch(actions.fetchEmailServerFilterEmailServer(filter))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(EmailServer))
